// src/hooks/useUserData.ts
import { useEffect, useState } from 'react';
import { useAuth } from '../services/AuthContext';

/**
 * Custom hook to get logged-in user and login status
 */
export const useUserDataNew = () => {
  const { user: authUser, token } = useAuth();
  const [user, setUser] = useState(authUser);
  const [isLoggedIn, setIsLoggedIn] = useState(!!token);

  useEffect(() => {
    setUser(authUser);
    setIsLoggedIn(!!token);
  }, [authUser, token]);
  

  return {
    user,
    isLoggedIn,
  };
};

export default useUserDataNew;
